// extracted by css-extract-rspack-plugin
module.exports =  {"root":"c2a9c2f917","button":"b02de821d3","prevDirection":"b2e01871d5","nextDirection":"ec43957067"};